import { Styles } from "@chakra-ui/theme-tools";

export const styles: Styles = {};
